<h2>{{verb}} Back-end User</h2>

<div class="button_row">
    <button mat-raised-button
            routerLink="/backend-users">Back</button>
</div>

<form [formGroup]="form"
      (ngSubmit)="submit()">
    <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput
               required
               formControlName="email">
        <mat-error>{{fields.email.errors}}</mat-error>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Role</mat-label>
        <mat-select formControlName="type">
            <mat-option *ngFor="let type of TYPES" [value]="type">{{type}}</mat-option>
        </mat-select>
    </mat-form-field>
    <div class="button_row">
        <button mat-raised-button
                color="primary"
                [disabled]="!canSubmit()"
                type="submit">{{verb}} User</button>
        <button mat-raised-button
                color="warn"
                *ngIf="user && !user.disabled"
                type="button"
                (click)="disableUser()">Disable User</button>
        <button mat-raised-button
                color="warn"
                *ngIf="user?.disabled"
                type="button"
                (click)="enableUser()">Enable User</button>
    </div>
</form>

